import React, { useEffect, useState } from "react";
import { DollarSign, CheckCircle, AlertCircle, IndianRupeeIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";
import TopBar from "../components/TopBar";
import './css/SchoolFee.css';
import axios from "./../axios";
const SchoolFee = ({ setSideBar, setSettingDrawer }) => {
  const navigate = useNavigate();
  // Placeholder data for fees; replace with backend API
  const [feeData,SetFeeData] = useState([
    { month: "not found", year: 2025, fee: 0, status: "Paid" },
 
  ]);
    const [isLoading, setIsLoading] = useState(true);
  
useEffect(()=>{
const GetFee=async ()=>{
  try{ 
    setIsLoading(true);
  const token=localStorage.getItem('student_token');
const fee_data=await axios.get('student/fee',{
  headers:{Authorization:'Bearer '+token}
});
SetFeeData(fee_data.data);
  }catch(error){
    console.log('Consoled Error:'+error);
  }finally{
    setIsLoading(false);
  }
}
GetFee();
},[])
  const handleFeeClick = (month, year) => {
    navigate(`/student/fee-receipt/${month}/${year}`);
  };

  return (
    <>
      <TopBar title="School Fees" setSideBar={setSideBar} setSettingDrawer={setSettingDrawer} />
      <div className="school-fee-container">
        <div className="school-fee-header">
          <IndianRupeeIcon size={24} className="header-icon" />
          <h2>School Fees</h2>
        </div>
        <div className="fee-list">
          <div className="fee-list-header"  style={{display:'flex',justifyContent:'space-between'}}>
            <span className="header-month">Month</span>
            
            <span className="header-status">Balance</span>
          </div>
          {isLoading?(<>
          {[...Array(12)].map((_, i) => (
            <div
             
              className="fee-item skeleton-assignment"
              
              role="button"
              tabIndex={0}
              
            >
              <div className="fee-icon skeleton-icon">
                 
              </div>
              <div className="fee-content">
                <span className="fee-month skeleton-title"> </span>
                <span className="fee-amount skeleton-title"> </span>
                <span className={`fee-status   skeleton-title`}>
                   
                </span>
              </div>
            </div>
          ))}
          {feeData.length === 0 && (
            <div className="no-fees">
              <DollarSign size={40} className="no-fees-icon" />
              <p>No fee records available</p>
            </div>
          )}
          </>):(
            <>
            {feeData.map((fee, index) => (
            <div
              key={`${fee.month}-${fee.year}`}
              className="fee-item"
              onClick={()=>handleFeeClick(fee.month,fee.year)}
              role="button"
              tabIndex={0}
              onKeyDown={(e) => e.key === "Enter" && handleFeeClick(fee.month, fee.year)}
            >
              <div className="fee-icon">
                {fee.status === "Paid" ? (
                  <CheckCircle size={20} className="status-paid" />
                ) : (
                  <AlertCircle size={20} className="status-pending" />
                )}
              </div>
              <div className="fee-content">
                <span className="fee-month">{fee.month} </span>
                <span className="fee-amount">₹{fee.fee.toFixed(2)}</span>
                <span className={`fee-status ${fee.status.toLowerCase()}`}>
                  {fee.status=='Paid'?fee.status:'₹'+fee.balance}
                </span>
                 
              </div>
            </div>
          ))}
          {feeData.length === 0 && (
            <div className="no-fees">
              <DollarSign size={40} className="no-fees-icon" />
              <p>No fee records available</p>
            </div>
          )}
            </>
          )}
          
        </div>
      </div>
    </>
  );
};

export default SchoolFee;